module.exports = __webpack_public_path__ + "img/100-pakistan.41cde439.svg";